import React, { Component } from 'react';

class IconChatAttachment extends Component {
    render() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="33"
                fill="none"
                viewBox="0 0 32 33"
            >
                <path
                    fill="#000"
                    d="M21.016 2.5c3.864.226 6.75 2.07 8.23 5.85 1.418 3.608.815 7.004-1.631 9.975-.477.57-.991 1.101-1.505 1.632-3.15 3.343-6.311 6.672-9.46 10.002-.54.57-1.104.69-1.669.358-.69-.411-.853-1.366-.364-2.016a6.31 6.31 0 01.276-.319c3.5-3.7 6.989-7.388 10.489-11.09.765-.808 1.355-1.737 1.706-2.838.79-2.454.05-5.386-1.794-7.11-1.418-1.313-3.061-1.884-4.93-1.698-1.518.146-2.823.836-3.902 1.976-3.588 3.794-7.176 7.575-10.752 11.382-1.066 1.14-1.418 2.52-.991 4.06.426 1.538 1.443 2.493 2.923 2.811 1.217.266 2.308-.08 3.25-.928.1-.093.188-.186.275-.279l9.736-10.294c.502-.53.615-1.127.326-1.698-.364-.716-1.23-.928-1.844-.464a3.632 3.632 0 00-.326.305c-2.083 2.202-4.178 4.404-6.26 6.62-.565.597-1.293.65-1.832.146a1.394 1.394 0 01-.176-1.818c.063-.08.125-.159.2-.239 2.121-2.241 4.229-4.483 6.361-6.712 1.33-1.393 3.237-1.645 4.806-.623 2.007 1.313 2.396 4.31.802 6.142-.087.092-.175.199-.263.291l-9.673 10.228c-.966 1.034-2.107 1.738-3.462 1.976-2.271.398-4.228-.252-5.834-2.016-2.359-2.613-2.309-6.818.188-9.445 3.588-3.767 7.164-7.56 10.74-11.355 1.316-1.393 2.885-2.281 4.716-2.64.552-.08 1.104-.106 1.644-.172z"
                ></path>
            </svg>
        );
    }
}

export default IconChatAttachment;